module.exports = __webpack_public_path__ + "img/imagen4.32d1f02b.png";